import React, { useEffect, useState } from "react";
import { titleIcon, titleIcon2 } from "../../assets/images";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet";

const About = () => {
  const { t, i18n } = useTranslation();

  const currentLanguage = i18n.language; // Aktif dili alıyoruz
  const { id } = useParams();
  const [single, setSingle] = useState(null);
  const [about, setAbout] = useState([]);

  useEffect(() => {
    getAbout();
  }, []);

  const getAbout = async () => {
    try {
      const response = await axios.get(
        `https://www.elzabeauty.az/elza/about.php`,
        { withCredentials: false }
      );
      setAbout(response.data.data[0]);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  useEffect(() => {
    const getSeoTags = async () => {
      try {
        const response = await axios.get(
          "https://www.elzabeauty.az/elza/seoTagsAbout.php"
        );
        const data = response.data.data || [];

        setSingle(data[0]);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    getSeoTags();
  }, [id]);

  const getLocalizedField = (item, fieldBase) => {
    if (currentLanguage === "en")
      return item[`${fieldBase}En`] || item[fieldBase];
    if (currentLanguage === "ru")
      return item[`${fieldBase}Ru`] || item[fieldBase];
    return item[fieldBase]; // default: az
  };

  return (
    <>
      {single && (
        <Helmet>
          <title>{getLocalizedField(single, "meta_tag_title")}</title>
          <meta
            name="description"
            content={getLocalizedField(single, "meta_tag_description")}
          />
          <meta
            name="keywords"
            content={getLocalizedField(single, "meta_tag_keywords")}
          />
        </Helmet>
      )}
      <div className="mt-10 md:mt-20">
        <div className="max-w-containerSm md:max-w-container mx-auto md:flex justify-between">
          <div className="md:w-[460px]">
            <img
              alt="About"
              className="md:w-[325px] mx-auto"
              src={`https://www.elzabeauty.az/elza/${about.image}`}
            ></img>
          </div>
          <div className="md:w-[780px] text-firstColor mt-8 md:mt-0">
            <div className="flex justify-center">
              <div className="flex items-center">
                <img
                  alt="Title Icon"
                  className="w-[50px] h-auto mr-2"
                  src={titleIcon}
                ></img>
                <p className="text-[24px] md:text-[28px] font-semibold text-center md:text-left text-[#181D27]">
                  {t("Haqqımızda")}
                </p>
                <img
                  alt="Title Icon"
                  className="w-[50px] h-auto ml-2"
                  src={titleIcon2}
                ></img>
              </div>
            </div>
            <p className="text-center font-medium">
              {getLocalizedField(about, "title")}
            </p>
            <p
              className="mt-4"
              dangerouslySetInnerHTML={{
                __html: getLocalizedField(about, "content"),
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
